import { httpInstance } from '@/services/httpInstance';

const getFeaturesFlagService = async () => {
  let res;
  const endpoint = '/back-office/v1/features-flag';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getFeaturesFlagService;
